import localStorage from "store2";

interface PusherClientConfig {
	clientKey: string;
	cluster: string;
	authEndpoint: string;
	auth: {
		params: {
			store: string;
			mode: string;
		};
		headers?: Record<string, string>;
	};
}

const client: PusherClientConfig = {
	clientKey: import.meta.env.VITE_PUSHER_KEY as string,
	cluster: "ap1",
	authEndpoint: `${import.meta.env.VITE_HUB_URI}/pusher/auth`,
	auth: {
		params: {
			store: localStorage.get("storeId") || "",
			mode: "manage",
		},
		headers: {},
	},
};

const pusherConfig = {
	client,
};

export default pusherConfig;
